import { render, staticRenderFns } from "./TablePagination.vue?vue&type=template&id=e7cd0c38&scoped=true&"
import script from "./TablePagination.vue?vue&type=script&lang=ts&"
export * from "./TablePagination.vue?vue&type=script&lang=ts&"
import style0 from "./TablePagination.vue?vue&type=style&index=0&id=e7cd0c38&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7cd0c38",
  null
  
)

export default component.exports